
import businessApi from "@/common/api/business";
import {Component, Vue} from "vue-property-decorator";
const default_service_params = {
  is_status: 1,
  desk_id: ''
}
@Component({})
export default class CancelMergePools extends Vue {
  private visible: boolean = false
  private businessApi: any = new businessApi();
  private tableData: any = []
  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  }

  private service_params = {
    ...default_service_params
  }

  private show(pool_info:any={}): void {
    console.log('球桌信息', pool_info)
    this.service_params = { ...default_service_params}
    this.tableData = []
    this.tablePage.pageNo = 1
    if(pool_info.id){
      this.service_params.desk_id = pool_info.id
    }
    this.visible = true
    this.getTableList()
  }
  private loading:boolean = false
  private getTableList(): void {
    this.loading = true
    this.businessApi.serviceLists(
        {
          ...this.service_params,
          page: this.tablePage.pageNo,
          limit: this.tablePage.pageSize,
        },
        (res: any) => {
          this.tableData = res.data.list
          this.tablePage.totalCount = res.data.count;
          this.tablePage.pageNo = res.data.page;
          this.tablePage.pageSize = res.data.prepage;
          this.loading = false
        }
    );
  }
  private changeStatus(status:number){
    this.service_params.is_status = status
    this.getTableList()
  }
  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;
    this.getTableList();
  }

  private comfirm(row: any) {
    this.businessApi.servicePass({
      id: row.id
    }, ((res: any) => {
      this.$message.success("操作成功");
      this.getTableList()
    }))
  }

  private refuse(row: any) {
    this.$confirm(`确认拒绝吗？`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      this.businessApi.serviceRefuse({
        id: row.id
      }, ((res: any) => {
        this.$message.success("操作成功");
        this.getTableList()
      }))
    })
  }

  private partPassComfirm(row: any) {
    console.log(this.partPassGoods)
    const cart_goods = this.partPassGoods.map((item:any)=>{
      return `${item.id}=${item.num}`
    }).toString()
    console.log(cart_goods)
    this.businessApi.servicePartPass({
      id: this.partPassId,
      cart_goods: cart_goods
    }, ((res: any) => {
      this.$message.success("操作成功");
      this.getTableList()
      this.partPassGoodsPopoverVisible = false
    }))
  }

  private partPassGoods:any[] = []
  private partPassId:string = ''
  private partPassGoodsPopoverVisible: boolean = false
  private showPartPassGoodsPopover(index:number){
    this.partPassGoods = JSON.parse(JSON.stringify(this.tableData[index].context.goods))
    this.partPassId = this.tableData[index].id
    this.partPassGoodsPopoverVisible = true
  }
  private minusGood(item:any,index:number){
    this.partPassGoods[index]['num'] = --item.num
  }
}

